// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Placeholder color */
.time-picker .ant-picker-input > input::placeholder {
  color: white; /* Placeholder color */
}
`, "",{"version":3,"sources":["webpack://./src/components/TimePicker/TimePickerCss.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,YAAY,EAAE,sBAAsB;AACtC","sourcesContent":["/* Placeholder color */\n.time-picker .ant-picker-input > input::placeholder {\n  color: white; /* Placeholder color */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
